import React from "react";
import styled from 'styled-components';
import { colours } from "../Styles";
import FlexSpaceCenter from './FlexSpaceCenter';
import MaxContent from './MaxContent';
import FlexCenterCenter from "./FlexCenterCenter";
import ContactItem from './ContactItem';
import { icons } from '../img/Icons';
import { heights } from '../Styles';

function ContactBar() {
    const { phone, mail, calendar } = icons;
    const { transpBlack } = colours;
    const { contactBar } = heights;
    const ContactBar = styled.div`
    height: ${contactBar};
    width: 100%;
    background: ${transpBlack};
    position: fixed;
    bottom: 0;
    visibility: hidden;
    @media only screen and (max-width: 600px) {
        visibility: visible;
        z-index: 5;
    }
    `;
  return (
    <ContactBar>
        <FlexCenterCenter>
            <MaxContent>
                <FlexSpaceCenter>
                    <ContactItem icon={phone} content="" url="tel:647-973-3714"/>
                    <ContactItem icon={calendar} content="" url="#/book"/>
                    <ContactItem icon={mail} content="" url="mailto:precisiondetailgta@gmail.com"/>
                </FlexSpaceCenter>
            </MaxContent>
        </FlexCenterCenter>
    </ContactBar>
  );
}

export default ContactBar;
